import React from 'react';
import Card from "@mui/joy/Card";
import Typography from "@mui/joy/Typography";
import {CardOverflow} from "@mui/joy";

// components
import RouteStateCardInner from "./RouteStateCardInner";


class RouteStateCard extends React.Component {
    render() {
        return (
            <Card
                variant={'plain'}
                sx={{
                    mb: 2,
                }}
                size={'sm'}
            >
                <CardOverflow
                    variant={'soft'}
                    color={this.props.state.stage.color}
                >
                    <Typography
                        level={'body-md'}
                        sx={{
                            alignSelf: 'center',
                            p: 1,
                        }}
                    >
                        {this.props.state.stage.title}
                    </Typography>
                </CardOverflow>
                <RouteStateCardInner
                    state={this.props.state}
                    conditions={true}
                />
            </Card>
        )
    }
}

export default RouteStateCard